// extracted by mini-css-extract-plugin
module.exports = {"entering":"accordionItem_entering__4kN4r","scale-in":"accordionItem_scale-in__yObyp","exiting":"accordionItem_exiting__c3gw4","scale-out":"accordionItem_scale-out__AIKhA"};